import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    subjectPaperListLoading: false,
    subjectPaperListSuccess: null,
    subjectPaperListError: '',

    getSubjectPaperLoading: false,
    getSubjectPaperSuccess: null,
    getSubjectPaperError: '',

    createSubjectPaperLoading: false,
    createSubjectPaperSuccess: {},
    createSubjectPaperError: '',

    subjectPaperDetailsLoading: false,
    subjectPaperDetailsSuccess : {},
    subjectPaperDetailsError : '',
}

export const subjectPaperSlice = createSlice({
    name: 'SubjectPaper',
    initialState, 
    reducers: {
        setSubjectPaperListLoading: (state) => {
            state.subjectPaperListLoading = true;
            state.subjectPaperListSuccess = null;
            state.subjectPaperListError = '';
        },
        setSubjectPaperListSuccess: (state, action) => {
            state.subjectPaperListLoading = false;
            state.subjectPaperListSuccess = action.payload;
            state.subjectPaperListError = '';
        },
        setSubjectPaperListError: (state, action) => {
            state.subjectPaperListLoading = false;
            state.subjectPaperListSuccess = null;
            state.subjectPaperListError = action.payload;
        },
        setGetSubjectPaperLoading: (state) => {
            state.getSubjectPaperLoading = true;
            state.getSubjectPaperSuccess = {};
            state.getSubjectPaperError = '';
        },
        setGetSubjectPaperSuccess: (state, action) => {
            state.getSubjectPaperLoading = false;
            state.getSubjectPaperSuccess = action.payload;
            state.getSubjectPaperError = '';
        },
        setGetSubjectPaperError: (state, action) => {
            state.getSubjectPaperLoading = false;
            state.getSubjectPaperSuccess = {};
            state.getSubjectPaperError = action.payload;
        },
        setCreateSubjectPaperLoading: (state) => {
            state.createSubjectPaperLoading = true;
            state.createSubjectPaperSuccess = {};
            state.createSubjectPaperError = '';
        },
        setCreateSubjectPaperSuccess: (state, action) => {
            state.createSubjectPaperLoading = false;
            state.createSubjectPaperSuccess = action.payload;
            state.createSubjectPaperError = '';
        },
        setCreateSubjectPaperError: (state, action) => {
            state.createSubjectPaperLoading = false;
            state.createSubjectPaperSuccess = {};
            state.createSubjectPaperError = action.payload;
        },

        setSubjectPaperDetailsLoading: (state) => {
            state.subjectPaperDetailsLoading = true;
            state.subjectPaperDetailsSuccess = {};
            state.subjectPaperDetailsError = '';
        },
        setSubjectPaperDetailsSuccess: (state, action) => {
            state.subjectPaperDetailsLoading = false;
            state.subjectPaperDetailsSuccess = action.payload;
            state.subjectPaperDetailsError = '';
        },
        setSubjectPaperDetailsError: (state, action) => {
            state.subjectPaperDetailsLoading = false;
            state.subjectPaperDetailsSuccess = {};
            state.subjectPaperDetailsError = action.payload;
        },

        resetSubjectDetails: (state) => {
            state.getSubjectPaperSuccess = {};
            state.createSubjectPaperSuccess = {};
        },
    }
})

export const { setSubjectPaperListLoading, setSubjectPaperListSuccess, setSubjectPaperListError,
    setGetSubjectPaperLoading, setGetSubjectPaperSuccess, setGetSubjectPaperError, 
    resetSubjectDetails,
    setSubjectPaperDetailsLoading, setSubjectPaperDetailsSuccess, setSubjectPaperDetailsError,
    setCreateSubjectPaperLoading, setCreateSubjectPaperSuccess, setCreateSubjectPaperError, 
} = subjectPaperSlice.actions;


export default subjectPaperSlice.reducer;